import cx from "classnames";
const Radio = ({
  children,
  name,
  id,
  className,
  checked,
  value,
  onChange,
  variant,
  ...other
}) => (
  <label
    htmlFor={id}
    className="relative flex w-full cursor-pointer items-center"
    {...other}
  >
    <span className="relative flex size-5 shrink-0 items-center justify-center rounded-full bg-white">
      <input
        className="checked:border-radio-checkedBorder border-darkgray absolute size-full appearance-none rounded-full border-2 focus:outline-none"
        id={id}
        aria-labelledby={id}
        type="radio"
        checked={checked}
        onChange={onChange}
        name={name}
      />
      <div
        className={cx("z-1 bg-radio-checkedBg h-[50%] w-[50%] rounded-full", {
          hidden: !checked,
        })}
      />
    </span>
    {children}
  </label>
);

export default Radio;
